import React from "react"
import useSearchContext from "./use-search-context"
import { useSearchSelector } from "./search-redux-context"

type usePaginationLegacyReturn = {
  setCurrentPage(page: number): void
  setPageSize(size: number): void
  currentPage: number
  pagingStart: number
  pagingEnd: number
  totalPages: number
  pageSize: number
  totalResults: number
}
/**
 * @deprecated
 */
export default function usePaginationLegacy(): usePaginationLegacyReturn {
  const { pagination, search } = useSearchContext()
  const paginationInfo = useSearchSelector(pagination.select)

  return React.useMemo(
    () => ({
      setCurrentPage(page: number) {
        pagination.setPage(page)
        search()
      },
      setPageSize(size: number) {
        pagination.setSize(size)
        search()
      },
      ...{
        currentPage: paginationInfo.pageNumber,
        pagingEnd: paginationInfo.pageEnd,
        pagingStart: paginationInfo.pageStart,
        pageSize: paginationInfo.pageSize,
        totalPages: paginationInfo.pageCount,
        totalResults: paginationInfo.resultCount,
      },
    }),
    [pagination, paginationInfo, search],
  )
}
